export default __webpack_public_path__ + "static/media/rabbitHole.fd8a1344.png";